import React from 'react';
import '../template-file-css/document-file-template.css';


export const NWBH_ConsentForTreatment = ({
    itemsRef,
    showErrorFor,
}) => {

    return (
        <form id='NWBH_ConsentForTreatment' className='file-pdf-document'>
            <div className='file-template'>

                <p className='w-750'>
                    I intend to voluntarily enter treatment and recognize that my treatment may include such
                    techniques such as case management, group therapy, individual therapy, social
                    rehabilitation counseling, psychosocial rehabilitation services, medication management,
                    and substance abuse services.<br />
                    <hr />
                    I hereby authorize NORTHWEST BEHAVIORAL HEALTH SERVICES, INC., to
                    release any and all information pertaining to my treatment to all programs and
                    departments within this agency. This exchange of information shall relate to any
                    examination or assessment of my behavioral health furnished from my medical records.
                    Information being furnished from my medical records shall be treated as
                    CONFIDENTIAL by NORTHWEST BEHAVIORAL HEALTH SERVICES, INC.
                    Release of information concerning my treatment or illness to any other agency shall be
                    made only after I have given approval in writing. This authorization and consent shall
                    remain in effect as long as I am a client, but is subject to revocation by me at any time.<br />
                    <hr />
                    I agree to assign to NORTHWEST BEHAVIORAL HEALTH SERVICES, INC., all
                    insurance benefits, not to exceed the total charge, pertaining to my treatment. If required,
                    I will furnish a notice of claim to insurer. I agree for the agency to release any
                    information in its records to my insurance companies and/or sponsoring agencies for the
                    purpose of verifying diagnosis, treatment or other necessary data.<br />
                    <hr />
                    I have read and understand this consent for treatment and have voluntarily executed it.
                </p>

                <p className='signature w-750'>&nbsp;</p>
                <p className='small w-375'> Signature</p>


                <p className='w-750'>All facilities of Northwest Behavioral Health Services, Inc., are made available to
                    clients without regards to race, color, religion, nation origin, sex, or handicap.</p>

            </div>
        </form>

    )
}

